<template lang="pug">
v-window(v-model="window")
  v-window-item
    v-list
      v-list-item(
        v-for="(i, idx) in items" :key="idx"
        @click="i.method"
      )
        v-list-item-icon
          v-icon {{  i.icon }}
        v-list-item-content
          v-list-item-title {{ i.title }}
          v-list-item-subtitle(v-if="i.chip")
            v-chip(color="warning" x-small) {{  i.chip }}
  v-window-item
    h4 Не сохраненные задания:
    server-data(
      ref="draftData"
      :method="$api.tasks.getDraft"
      :query="{ [`search[${UNITS_MODEL[taskModel].search}]`]: modelId, 'per-page': 5, }"
      v-slot="{ serverData, loadMoreItems, loading, pagination }"
    )
      v-skeleton-loader(
        v-if="!serverData || loading"
        type="list-item@3"
      )
      v-list-item(v-else-if="!serverData.length && !loading")
        v-list-item-title Черновиков пока нет
      .display-contents(v-else)
        v-list-item(
          width="100px"
          link
          v-for="draft in serverData" :key="draft.id"
          :to=`{
            name: 'TaskEdit',
            query: { model: taskModel, id: modelId, type: 'draft', draftId: draft.id }
          }`
        )
          v-list-item-title.text-truncate {{draft.draft_task.title}}
          v-list-item-action
            v-btn(
              icon
              color="error"
              @click.stop.prevent="deleteDraft(draft.id, pagination.page)"
            )
              v-icon mdi-close
        v-list-item(v-if="pagination && pagination.total > 1")
          v-list-item-content
            v-pagination(
              v-model="pagination.page"
              :length="pagination.pages"
              circle
              @input="(val) => loadItems(val, 'draftData')"
            )
    v-btn(outlined color="primary" @click="window = 0")
      v-icon(left) mdi-arrow-left
      span вернуться
  v-window-item
    server-data(
      ref="templateData"
      :method="$api.tasks.getTaskList"
      :query="{ [`search[available_for_copy]`]: 1 }"
      v-slot="{ serverData, loadMoreItems, loading, pagination }"
    )
      v-list(max-height="400").overflow-auto
        v-skeleton-loader(
          v-if="loading"
          type="list-item@3"
        )
        v-list-item(
          link
          v-for="item in serverData"
          :key="item.id"
          @click="cloneTask(item.id)"
        )
          v-list-item-title.text-truncate {{item.title}}
          v-list-item-icon
            v-icon mdi-chevron-right
      v-pagination(
        v-if="pagination && pagination.total > 1"
        v-model="pagination.page"
        :length="pagination.pages"
        circle
        @input="(val) => loadItems(val, 'templateData')"
      )
    v-btn(outlined color="primary" @click="window = 0")
      v-icon(left) mdi-arrow-left
      span вернуться
</template>
<script>
import { UNITS_MODEL } from '@/modules/CourseManagement/constants';

export default {
  props: {
    taskModel: { type: String, required: true },
    modelId: { type: Number, required: true },
  },
  data() {
    return {
      hasDrafts: false,
      UNITS_MODEL,
      window: 0,
    };
  },
  computed: {
    items() {
      return [
        {
          icon: 'mdi-plus',
          title: 'Создать новое задание',
          method: () => {
            this.$router.push({ name: 'TaskCreate', query: { model: this.taskModel, id: this.modelId } });
            this.$modals.close();
          },
        },
        {
          icon: 'mdi-content-copy',
          title: 'Создать задание на основе ранне созданного',
          method: () => { this.window = 2; },
        },
        {
          icon: 'mdi-pencil',
          title: 'Продолжить редактирование',
          chip: this.hasDrafts ? 'Есть не сохраненные задания' : '',
          props: {
            disabled: !this.hasDrafts,
          },
          method: () => { this.window = 1; },
        },
      ];
    },
  },
  async created() {
    const { data } = await this.$api.tasks.getDraft({ [`search[${UNITS_MODEL[this.taskModel].search}]`]: this.modelId, 'per-page': 1 });
    this.hasDrafts = !!data.data.length;
  },
  methods: {
    async loadItems(page, refName) {
      // this.$refs[refName].loading = true;
      await this.$refs[refName].init(page);
      // this.$refs[refName].serverData = resp.data.data;
      // this.$refs[refName].loading = false;
    },
    async cloneTask(taskId) {
      const params = {
        relation_model: this.taskModel,
        relation_id: this.modelId,
      };
      const { data } = await this.$api.tasks.cloneTask(taskId, params);
      const task = data.data;
      this.$router.push({
        name: 'TaskEdit',
        params: { id: task.id },
        query: { model: this.taskModel, type: 'copy', id: this.modelId },
      });
      this.$modals.close();
    },
  },
};
</script>
